export const MCP_SCOPE_DESCRIPTIONS: Record<string, string> = {
  "mcp:read": "View Trip and event summaries (required).",
  "mcp:details": "View event details, costs, minimal Trip member references and your personal packing lists.",
  "mcp:write": "Create or update Trips, events, participation, costs and your personal packing lists.",
  "mcp:delete": "Remove events, participation, costs and packing data after fresh explicit confirmation for each action. Requires write access. This permission alone cannot delete a Trip.",
  "mcp:trip-delete": "Permanently delete an entire unlocked Trip you own. Each deletion requires a saved preview and your fresh, explicit confirmation. Requires read, write and delete access.",
  "offline_access": "Keep the assistant connection active through refresh tokens until you disconnect.",
};

export function describeScopes(scopes: readonly string[]) {
  return scopes.map(scope => ({ scope, description: Object.hasOwn(MCP_SCOPE_DESCRIPTIONS, scope) ? MCP_SCOPE_DESCRIPTIONS[scope] : "Permission supplied by the authorization server." }));
}

// Client names are self-asserted. Display the verified/granted identity's origin
// as text; never fetch or navigate to its arbitrary metadata URL.
export function clientOrigin(clientId: string): string | null {
  try {
    const url = new URL(clientId);
    return url.protocol === "https:" && !url.username && !url.password ? url.origin : null;
  } catch { return null; }
}
